import { isInsightCategory, type InsightCategory } from '../../content/insight-categories';
import { SITE_CONFIG } from '../../config/site-config';
import { insightsList } from '../../components/insights-list';
import { $, $$ } from '../../lib/dom';
import { nextRovingItem } from '../../lib/roving-focus';
import { loadInsights } from './insights-service';

const tabCategory = (tab: HTMLElement): InsightCategory => {
  const category = tab.dataset.cat;
  return isInsightCategory(category) ? category : '';
};

/** Category tabs on /insights, plus the asynchronous article load. */
export function initInsights(root: HTMLElement): void {
  const tabs = $$('[data-cat]', root);
  const panel = $('#posts', root);
  if (!panel) return;

  void loadInsights().then(() => {
    const selected = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
    panel.innerHTML = insightsList(selected ? tabCategory(selected) : '');
  });

  const select = (tab: HTMLElement, focus = false): void => {
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
    });
    const category = tabCategory(tab);
    panel.innerHTML = insightsList(category);
    const query = category ? `?category=${category}` : '';
    if (SITE_CONFIG.ROUTING === 'path') history.replaceState(null, '', `/insights${query}`);
    else history.replaceState(null, '', `${location.pathname}${location.search}#/insights${query}`);
    if (focus) tab.focus();
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      select(tab);
    });
    tab.addEventListener('keydown', (event) => {
      const next = nextRovingItem(tabs, tab, event.key, 'horizontal');
      if (next) {
        event.preventDefault();
        select(next, true);
      }
    });
  });
}
